import ChildForm from '../../components/Children/Form';

import PageWrapper from '../../components/PageWrapper';

const Page: React.FC = () => {
  return (
    <PageWrapper pageTitle="New Child">    
      <ChildForm />
    </PageWrapper>
  )
}

export default Page;